module.exports = __webpack_public_path__ + "img/local-2.a9dee4bd.jpg";